import React, {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import DynamicRendering from '@s-ui/react-perf-dynamic-rendering'

function PerfDynamicRendering({children, disabled, forceRender, height, placeholder, rootMargin}) {
  const {browser} = useContext(Context)

  const {userAgent = ''} = browser

  return (
    <DynamicRendering
      disabled={disabled}
      forceRender={forceRender}
      height={height}
      placeholder={placeholder}
      rootMargin={rootMargin}
      userAgent={userAgent}
    >
      {children}
    </DynamicRendering>
  )
}

PerfDynamicRendering.displayName = 'PerfDynamicRendering'

PerfDynamicRendering.propTypes = {
  children: PropTypes.any,
  disabled: PropTypes.bool,
  forceRender: PropTypes.bool,
  height: PropTypes.number,
  placeholder: PropTypes.any,
  rootMargin: PropTypes.string
}

export default PerfDynamicRendering
